import { FC, useMemo } from "react";
import PropertiesList from "./PropertiesList";
import { useProperty } from "@services";
import { useIsMutating } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import GathernIcon from "@assets/svg/gathern-icon.svg?react";

const GathernProperties: FC<{
  reset: (close: boolean) => void;
  onNext: () => void;
  name: string;
  targetPropertyId: string;
}> = ({ reset, onNext, name = "", targetPropertyId = "" }) => {
  const { addPropertyMutate, gathrenListingQuery, connectToNewChannelMutate } =
    useProperty();
  const mutating = useIsMutating();
  const { t } = useTranslation();
  const { mutate: addProperty } = addPropertyMutate({});
  const {
    data: gathrenListing,
    isLoading,
    isError: errorFetch,
  } = gathrenListingQuery();
  const {
    mutate: connectNewChannelMutaion,
    isPending,
    isError,
    isSuccess,
  } = connectToNewChannelMutate({
    onSuccess: () => {},
    onError: () => {},
  });

  const onLink = (properties: any[]) => {
    const payload: any = properties?.map((property) => ({
      propertyLocation: property?.location?.address,
      propertyId: 0,
      propertyName: property?.title,
      propertyIsDeteled: false,
      propertyCreateDate: null,
      gathrenUnitId: `${property?.id}`,
      airbnbUnitId: "",
      chaletId: property?.chaletId,
      autoAccess: false,
      status: true,
      templateId: null,
      propertyImage: property?.image,
    }));
    connectNewChannelMutaion({
      propertyId: targetPropertyId,
      gathrenUnitId: payload[0].gathrenUnitId,
      airbnbUnitId: ``,
      chaletId: payload[0].chaletId,
      propertyName: payload[0]?.propertyName,
    });
    // addProperty(payload);
  };
  const list = useMemo(() => {
    return (
      gathrenListing?.chalets
        ?.map((c: any) => {
          return c.units?.map((u: any) => ({
            ...u,
            location: c.location,
            chaletId: c.id,
          }));
        })
        ?.flat() ?? []
    );
  }, [gathrenListing]);
  return (
    <>
      <PropertiesList
        name={name}
        loading={isLoading}
        channel={t("GATHERIN")}
        mutate={onLink}
        channelIcon={<GathernIcon />}
        propertyList={list}
        success={isSuccess}
        error={isError || errorFetch}
        reset={reset}
        mutating={mutating > 0}
        onNext={onNext}
      />
    </>
  );
};
export default GathernProperties;
